// extracted by mini-css-extract-plugin
export default {"container":"ArchiveSwitch_container__wjhXm","label":"ArchiveSwitch_label__ezVTb","icon":"ArchiveSwitch_icon__f348K","icon__unchecked":"ArchiveSwitch_icon__unchecked__HwlQb"};